import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFound from "../notFound";
import Login from "../login/login";
import ProtectedRoute from "./ProtectedRoute";
import Dashboard from "../pages/Dashboard";
import EmployeesList from "../pages/Employees/employeesList";

const RouteHandler = () => {
  return (
    <>
      <Suspense
        fallback={<div className="loader-div fullLoaderRoute">...loading</div>}
      >
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/employees" element={<EmployeesList />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </Suspense>
    </>
  );
};

export default RouteHandler;
